import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { TerminalWebComponentSchema } from '../types';

export class TerminalBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<TerminalWebComponentSchema> {
    throw new Error('Not implemented');
  }

  async checkFileExists(file): Promise<boolean> {
    throw new Error('Not implemented');
  }

  async getAuthenticationSettings(companyId) {
    throw new Error('Not implemented');
  }

  async isIdpRequestAuthorized(endpointId) {
    throw new Error('Not implemented');
  }
}
